import React, { useEffect } from "react";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";

const AnimatedSection = ({ children }) => {
  const controls = useAnimation();
  const [ref, inView] = useInView({
    threshold: 0.2,
    triggerOnce: false,
  });

  useEffect(() => {
    if (inView) {
      // When entering view, animate upward (from below to position)
      controls.start({
        opacity: 1,
        y: 0,
        transition: { duration: 0.6 },
      });
    } else {
      // When leaving view, animate downward (reverse animation)
      controls.start({
        opacity: 0,
        y: 50,
        transition: { duration: 0.6 },
      });
    }
  }, [controls, inView]);

  return (
    <motion.div ref={ref} initial={{ opacity: 0, y: 50 }} animate={controls}>
      {children}
    </motion.div>
  );
};

export default AnimatedSection;
